import { render } from "./HistoryItem.vue?vue&type=template&id=742e63d8&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"

import "./HistoryItem.vue?vue&type=style&index=0&id=742e63d8&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742e63d8"]])

export default __exports__